<template>
    <div class="dc-user-full is-accreditation">
        <h2>{{$t('views.createUserFull.accreditation.mainTitle')}}</h2>
        <h3>{{$t('views.createUserFull.accreditation.subTitle')}}</h3>
        <p>{{$t('views.createUserFull.accreditation.p[0]')}}</p>
        <ul>
            <li>{{$t('views.createUserFull.accreditation.ul[0]')}}</li>
            <li>{{$t('views.createUserFull.accreditation.ul[1]')}}</li>
            <li>{{$t('views.createUserFull.accreditation.ul[2]')}}</li>
        </ul>
        <span class="dc-user-full__diglink" @click="dialogShow = true;">{{$t('views.createUserFull.accreditation.secPopLink')}}</span>
        <div class="dc-user-full__btns">
            <el-button :class="{'is-selected': secTrue}" size="default" @click="onSecTrue(true)">{{$t('views.createUserFull.accreditation.secTrue')}}</el-button>
            <el-button :class="{'is-selected': !secTrue}" size="default" @click="onSecTrue(false)">{{$t('views.createUserFull.accreditation.secFalse')}}</el-button>
        </div>
        <el-button class="dc-user-full__btn-next" type="primary" @click="onNext">{{$t('views.createUserFull.btnNext')}}</el-button>
        <el-dialog
            class="dc-user-full__dialog"
            :visible.sync="dialogShow"
            width="80%"
            >
            <h3>{{$t('views.createUserFull.accreditation.popTitle')}}</h3>
            <p>{{$t('views.createUserFull.accreditation.popText[0]')}}</p>
            <ul>
                <li>{{$t('views.createUserFull.accreditation.popli[0]')}}</li>
                <li>{{$t('views.createUserFull.accreditation.popli[1]')}}</li>
                <li>{{$t('views.createUserFull.accreditation.popli[2]')}}</li>
            </ul>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogNotAllow"
            width="70%"
        >
            <h3>{{$t('views.createUserFull.accreditation.popNotAllow')}}</h3>
        </el-dialog>
        
    </div>
</template>

<script>
import { mapActions } from  'vuex';

export default {
    name: 'userFull',
    data () {
        return {
            secTrue: false,
            dialogShow: false,
            dialogNotAllow: false,
        }
    },
    methods: {
        ...mapActions([
            'updateUserFulled'
        ]),
        onSecTrue (j) {
            this.secTrue = j
        },
        onNext () {
            if (this.secTrue) return this.$router.push('/create-user-full-goals')
            this.dialogNotAllow = true
        },
    }
}
</script>